import PropTypes from "prop-types";
import React from "react";
import Layout from "../layouts/index.jsx";
import Header from "../layouts/header";
import Breadcrumb from "../containers/global/breadcrumb/index.jsx";
import Footer from "../layouts/footer";
import BlogData from "../data/blog.json";
import { slugify } from "../utils";
import BlogItemContainer from "../containers/blog/blog-item";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";

const BlogAuthor = ({
  match: {
    params: { author },
  },
}) => {
  const data = BlogData.filter((blog) => slugify(blog.author) === author);
  const authorTitle = data[0].author;
  return (
    <React.Fragment>
      <Layout>
        <SEO
          title="Blog Author | PalmCare Sinai Hospital"
          description="Browse health articles by author from PalmCare Sinai Hospital, Eldoret."
        />
        <div className="wrapper">
          <Header />
          <div className="main-content site-wrapper-reveal">
            <Breadcrumb
              prevs={[
                { text: "Home", path: "/" },
                { text: "Blog", path: "/blog" },
              ]}
              contentThree={authorTitle}
            />
            <BlogItemContainer data={data} />
          </div>
          <Footer />
          <ScrollToTop />
        </div>
      </Layout>
    </React.Fragment>
  );
};

BlogAuthor.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      author: PropTypes.string,
    }),
  }),
};

export default BlogAuthor;
